import EvalDelay from './src/main';

/* istanbul ignore next */
EvalDelay.install = function(Vue) {
  Vue.component(EvalDelay.name, EvalDelay);
};

export default EvalDelay;
